import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { RESET_PASSWORD } from '~/services/auth';
import { publicClient } from '~/services';
import Logo from '../shared/Logo';
import { Head } from '../shared/Head';

export const ResetPassword = () => {
  const [t] = useTranslation('login');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  const [resetPassword, { loading }] = useMutation(RESET_PASSWORD, {
    onCompleted: (data) => {
      if (data.response.hasError) {
        setError(data.response.message || t('error'));
        return;
      }
      navigate('/');
    },
    onError: () => {
      setError(t('error'));
    },
    client: publicClient,
  });

  const handleSubmit = async () => {
    if (password !== confirmPassword) {
      setError(t('password_mismatch'));
      return;
    }
    if (password.length < 8) {
      setError(t('password_too_short'));
      return;
    }

    const token = searchParams.get('token');
    if (!token) {
      setError(t('invalid_token'));
      return;
    }

    try {
      await resetPassword({
        variables: {
          data: {
            token,
            newPassword: password,
          },
        },
      });
    } catch (error) {
      setError(t('error'));
    }
  };

  return (
    <>
      <Head title={t('reset_password')} />
      <div className="md:hero h-screen bg-[url('./assets/background.png')] !bg-[length:20%_auto] p-4 md:p-0">
        <div className="card bg-base-100 flex h-fit w-full items-center shadow-xl md:h-[32rem] md:w-96">
          <Logo className="my-8 w-32 md:w-52" />
          <div className="flex w-full flex-col items-center gap-4 p-4">
            <h2 className="text-lg font-semibold">{t('reset_password')}</h2>
            <p className="text-center text-sm text-gray-600">
              {t('reset_password_instructions')}
            </p>
            <input
              type="password"
              className="input input-bordered w-full"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={t('placeholder_password')}
              autoComplete="new-password"
            />
            <input
              type="password"
              className="input input-bordered w-full"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder={t('placeholder_password')}
              autoComplete="new-password"
            />
            {error && (
              <div className="text-center text-sm text-red-500">{error}</div>
            )}
            <button
              className="btn btn-primary w-52 rounded-md"
              onClick={handleSubmit}
              disabled={loading}
            >
              {t('reset_password')}
            </button>
          </div>
          {loading && (
            <progress className="progress progress-primary mt-12 w-full"></progress>
          )}
        </div>
      </div>
    </>
  );
};
